import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import AppScrollbar from '../../../AppScrollbar';
import MainSidebar from '../../components/MainSidebar';
import Drawer from '@mui/material/Drawer';
import VerticalNav from '../../components/VerticalNav';
import SidebarWrapper from './SidebarWrapper';
import { useLayoutContext } from '@projectK/context/LayoutContextProvider';
import UserInfo from '../../components/UserInfo';
import FooterCard from '../../components/FooterCard';
import { useSidebarContext } from '@projectK/context/SidebarContextProvider';
import { useAuthMethod, useAuthUser } from '@projectK/hooks/AuthHooks';
import { Box, Divider } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import StorefrontIcon from '@mui/icons-material/Storefront';
import {isActualSuperAdmin, hasPermission, useRolePermissions,isActualAdmin } from '@projectK/context/RolesProvider';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';


const AppSidebar = (props) => {
  const { footer, footerType } = useLayoutContext();
  const { user } = useAuthUser();
  const { logout } = useAuthMethod();
    const { rolePermissions, swapRolePermissions } = useRolePermissions(); 

  const { sidebarTextColor } = useSidebarContext();

 const OwnerRoutes = () => [  {
    id: 'Settings',
    title: 'Settings',
    messageId: 'Settings',
    type: 'item',
    icon: <SettingsIcon />,
    url: '/settings',
    permissionKey:['Company Settings - General','Company Settings - Verbiage','My Locker - Account Info','Role And Permissions','Audit Logs','My Locker - Settings','Company Settings - Waiver Settings','Product Waivers Log','Company Settings - Waiver Logs','Company Settings - Convenience Fee','Company Settings - Promo Codes']
  }, 
  {
    id: 'Marketplace',
    title: 'Marketplace',
    messageId: 'Marketplace',
    type: 'item',
    icon: <StorefrontIcon />,
    url: '/admin/featuremarket',
    permissionKey:'Marketplace'
  },
];
 const allUsers = () => [ {
    id: 'logout',
    title: 'Sign out',
    messageId: 'Sign out',
    type: 'action', 
    icon: <LogoutRoundedIcon />,
    action: logout,
  },];

  const filteredMenu = OwnerRoutes().filter(item => {
    if (!item.permissionKey) return true; 

    if (Array.isArray(item.permissionKey)) {
      return item.permissionKey.some(key =>
        hasPermission(rolePermissions, key, 'read')
      );
    }
    return hasPermission(rolePermissions, item.permissionKey, 'read');
  });
  
  let roleAccessPermission = rolePermissions;
  if(isActualSuperAdmin(user) || isActualAdmin(user)){
   roleAccessPermission = swapRolePermissions
  }
  const hasServiceDeskPermission = hasPermission(roleAccessPermission, 'Support', 'read');
  const adminExtraMenu = hasServiceDeskPermission ? 2 : 1;
  const menuCount = (filteredMenu?.length || 0 ) +  adminExtraMenu
  const sidebarRoleClass = `isAdminSwaprole${menuCount}`;
  return (
    <>
      <Box sx={{ display: { xs: 'block', xl: 'none' } }}>
        <Drawer
          anchor={props.position}
          open={props.isNavCollapsed}
          onClose={props.toggleNavCollapsed}
          classes={{
            root: clsx(props.variant),
            paper: clsx(props.variant),
          }}
          style={{ position: 'absolute' }}
        >
          <SidebarWrapper className={`mini-toggle-sidebar ${sidebarRoleClass}`}>
            <MainSidebar
              style={{
                display: 'grid',
                gridTemplateRows: 'auto 1fr auto',
                height: '100vh',
              }}
            >
              <UserInfo color={sidebarTextColor} />
              <AppScrollbar
                sx={{
                  py: 2,
                  height: 'calc(100vh - 70px) !important',
                  '&.has-footer-fixed': {
                    height: 'calc(100vh - 117px) !important',
                  },
                }}
                scrollToTop={false}
              >
                <VerticalNav routesConfig={props.routesConfig} />
              </AppScrollbar>
              <Divider sx={{ my: 2 }} />
              <FooterCard allUsers={allUsers} filteredMenu={filteredMenu} hasServiceDeskPermission={hasServiceDeskPermission} />
            </MainSidebar>
          </SidebarWrapper>
        </Drawer>
      </Box>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <SidebarWrapper className={`mini-toggle-sidebar ${sidebarRoleClass}`}>
          <MainSidebar>
            <UserInfo color={sidebarTextColor} />
            <AppScrollbar
              className={clsx({
                'has-footer-fixed': footer && footerType === 'fixed',
              })}
              sx={{
                py: 2,
                height: 'calc(100vh - 70px) !important',
                '&.has-footer-fixed': {
                  height: 'calc(100vh - 117px) !important',
                },
              }}
              scrollToTop={false}
            >
              <VerticalNav routesConfig={props.routesConfig} />
            </AppScrollbar>
            <Divider sx={{ my: 2 }} />

            <FooterCard allUsers={allUsers} filteredMenu={filteredMenu} hasServiceDeskPermission={hasServiceDeskPermission} />
          </MainSidebar>
        </SidebarWrapper>
      </Box>
    </>
  );
};
export default AppSidebar;

AppSidebar.defaultProps = {
  variant: '',
  position: 'left',
};

AppSidebar.propTypes = {
  position: PropTypes.string,
  variant: PropTypes.string,
  toggleNavCollapsed: PropTypes.func,
  isNavCollapsed: PropTypes.bool,
  routesConfig: PropTypes.any,
};
